import { OwcTypography, OwcTooltip } from "@one/react";
import PropTypes from "prop-types";
import { valueOrEmpty } from "../../../../utils/helpers/text";
import { changeActionTypeToDisplay, isActionType } from "../../../shared/helpFunctions";

const ActionType = ({ type }) => {
  if (!isActionType(type)) {
    return null;
  }

  const displayText = valueOrEmpty(changeActionTypeToDisplay(type), false, "-");
  const tooltipId = `attr_${type}`;

  return (
    <div>
      <OwcTypography variant="caption">Action type</OwcTypography>

      <OwcTypography variant="button" id={tooltipId}>
        {displayText}
      </OwcTypography>
      <OwcTooltip anchor={tooltipId}>
        {displayText}
      </OwcTooltip>
    </div>
  );
};

ActionType.propTypes = {
  type: PropTypes.string
};

export default ActionType;
